/* Yake Mall — ürün sayfasında aynı modelin diğer renkleri (2 Eki 2026)
   Model kodu (SKU ilk parçası) ile Shopify tahminli aramasından kardeş ürünler bulunur,
   her birinin renk adı /products/<handle>.js'ten okunur. Tükenen renkler gösterilmez. */
(function () {
  function kok() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function renkAdi(p) {
    var opts = p.options || [];
    for (var i = 0; i < opts.length; i++) {
      var n = String(opts[i].name || '').toLowerCase();
      if (/renk|colou?r|цвет|لون/.test(n)) {
        var v = p.variants && p.variants[0];
        return v ? v['option' + (i + 1)] : (opts[i].values || [])[0];
      }
    }
    return '';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function gorsel(src) {
    if (!src) return '';
    src = String(src);
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function kur(kap) {
    if (kap.__ykRenk) return;
    kap.__ykRenk = true;
    var key = kap.getAttribute('data-key');
    var sku = String(kap.getAttribute('data-sku') || '').trim();
    var self = kap.getAttribute('data-handle');
    var liste = kap.querySelector('[data-yk-renk-liste]');
    var R = kok();
    /* 21 Eki: model kodu iki aşamalı. Dar kod = SKU'nun son (beden) parçası hariç; ilk parça bazı markalarda sezon kodu (HLSS23) */
    var parca = sku.split('-');
    var dar = parca.length >= 3 ? parca.slice(0, -1).join('-') : '';
    function kucuk(s) { return String(s || '').toLocaleLowerCase('tr'); }
    /* ad gövdesi: renk değerinin her kelimesi + yaygın renk adları çıkarılır (İndigo/indigo, Gb melanj/lacivert, Ekru - İndigo) */
    var RENKLER = 'siyah beyaz ekru krem bej taş tas gri füme fume antrasit lacivert mavi indigo açık acik koyu kırmızı kirmizi bordo pembe pudra fuşya fusya mor lila yeşil yesil haki çağla cagla mint zümrüt zumrut sarı sari hardal turuncu kiremit somon kahve kahverengi taba vizon camel tarçın tarcin altın altin gümüş gumus melanj multi desenli renkli black white red blue navy green beige brown grey gray pink'.split(' ');
    function govde(baslik, renk) {
      var b = ' ' + kucuk(baslik).normalize('NFC').replace(/[-–—,()\/\.]+/g, ' ').replace(/\s+/g, ' ') + ' ';
      var sil = kucuk(renk).normalize('NFC').split(/[^a-z0-9çğıöşüâîû]+/i).concat(RENKLER);
      sil.forEach(function (w) { if (w && w.length > 1) b = b.split(' ' + w + ' ').join(' '); });
      return b.replace(/\s+/g, ' ').trim();
    }
    var benimGovde = govde(kap.getAttribute('data-title'), kap.getAttribute('data-color'));
    function ara(q) {
      var url = R + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=10' +
        '&resources[options][fields]=variants.sku&resources[options][unavailable_products]=hide';
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
          ps = ps.filter(function (p) { return p.handle !== self && p.available !== false; });
          return Promise.all(ps.map(function (p) {
            return fetch(R + 'products/' + p.handle + '.js')
              .then(function (r) { return r.ok ? r.json() : null; })
              .catch(function () { return null; });
          }));
        })
        .then(function (l) { return (l || []).filter(function (p) { return p && p.available; }); });
    }
    var darAra = dar ? ara(dar).then(function (l) {
      return l.filter(function (p) { return (p.variants || []).some(function (v) { return String(v.sku || '').trim().indexOf(dar + '-') === 0; }); });
    }) : Promise.resolve([]);
    darAra
      .then(function (l) {
        if (l.length) return l;
        /* geniş arama: SKU ilk parçası çok genel olabilir (ATE, HLSS23) → ürün ADIYLA (renk çıkarılmış) ara, sonra aynı ilk parça + aynı ad şartı */
        return ara(benimGovde || key).then(function (l2) {
          return l2.filter(function (p) {
            return (p.variants || []).some(function (v) { return String(v.sku || '').split('-')[0].trim() === key; }) &&
              govde(p.title, renkAdi(p)) === benimGovde;
          });
        });
      })
      .then(function (list) {
        if (!list.length) return; /* tek renk → blok gizli kalır */
        var buton = function (href, img, ad, aktif) {
          return '<a class="yk-renk__oge' + (aktif ? ' is-active' : '') + '" href="' + esc(href) + '" title="' + esc(ad) + '"' + (aktif ? ' aria-current="true"' : '') + '>' +
            '<span class="yk-renk__btn">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="56" height="56">' : '') + '</span>' +
            '<span class="yk-renk__ad">' + esc(ad) + '</span></a>';
        };
        var html = buton(kap.getAttribute('data-url'), kap.getAttribute('data-img'), kap.getAttribute('data-color'), true);
        list.forEach(function (p) {
          html += buton(R + 'products/' + p.handle, gorsel(p.featured_image), renkAdi(p) || p.title, false);
        });
        liste.innerHTML = html;
        kap.hidden = false;
      })
      .catch(function () { /* sessiz: blok gizli kalır */ });
  }

  function hepsi() { document.querySelectorAll('[data-yk-renk]').forEach(kur); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hepsi);
  else hepsi();
})();
